import Swiper, { Navigation, Pagination } from 'swiper';
import lazyLoad from './../utils/lazy'

Swiper.use([Navigation, Pagination]);

const cFindTeamSlider = () => {

    const slider = new Swiper(".c-find-team-slider__slider", {
        slidesPerView: 'auto',
        spaceBetween: 32,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        navigation: {
            nextEl: '.c-find-team-slider__next',
            prevEl: '.c-find-team-slider__prev',
          },
    })
    slider.on('slideChange, init', function () {
        lazyLoad()
    });
}

export default cFindTeamSlider
